"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyBillingDataService = void 0;
const locale_1 = require("../utils/homeport/locale");
let policyBillingDataInstance;
class PolicyBillingDataService {
    static serviceName = 'policyBillingDataService';
    policy;
    issuanceDate;
    cancellationDate;
    expirationDate;
    total_payment_cycles = 10;
    showDownPaymentLine = false;
    showDue = false;
    payment_status = '';
    payment_status_title = (0, locale_1.t)('Boats_Policy_PaymentStatus');
    /** "9 of 10" string for monthly plans; empty for yearly / processing. */
    installment_status = '';
    policyStatusToLowercase = '';
    dateToDisplayUntil;
    constructor({ policy }) {
        policyBillingDataInstance = this;
        this.policy = policy;
        this.issuanceDate = policy?.IssuanceDate;
        this.cancellationDate = policy?.CancellationDate;
        this.expirationDate = policy?.ExpirationDate;
        this.policyStatusToLowercase = policy?.Status.toLowerCase();
        this.dateToDisplayUntil = this.expirationDate;
    }
    static getInstance() {
        return policyBillingDataInstance;
    }
    getPolicyStatusToLowercase() {
        return this.policyStatusToLowercase;
    }
    getPaymentStatusAndDownpayment() {
        if (!this.policy?.PaymentOption) {
            this.payment_status = 'Processing ...';
        }
        else if (this.policy?.PaymentOption === 'year') {
            if (this.policy?.DueInvoicesCount > 0) {
                this.payment_status = (0, locale_1.t)('Boats_Policy_PaymentStatus_InProgress');
            }
            else {
                this.payment_status = (0, locale_1.t)('Boats_Policy_PaymentStatus_PaidFull');
            }
        }
        else {
            /* Monthly plan — Payment status is the simple state ("Paid" / "In progress")
               and the cycle count goes into a separate `installment_status` row. */
            const RemainingBillingCycles = this.policy?.RemainingBillingCycles || 0;
            const DueInvoicesCount = this.policy?.DueInvoicesCount || 0;
            const total = this.total_payment_cycles;
            const paidCycles = (total - RemainingBillingCycles) - DueInvoicesCount;
            if (DueInvoicesCount) {
                if (RemainingBillingCycles == total) {
                    /* No installments paid yet — first cycle still due. */
                    this.payment_status = (0, locale_1.t)('Boats_Policy_PaymentStatus_InProgress');
                }
                else {
                    this.showDownPaymentLine = true;
                    this.showDue = true;
                    this.payment_status = (0, locale_1.t)('Boats_Policy_PaymentStatus_InProgress');
                    this.installment_status = `${paidCycles} ${(0, locale_1.t)('Boats_Policy_Of')} ${total}`;
                }
            }
            else {
                this.showDownPaymentLine = true;
                this.payment_status = (0, locale_1.t)('Boats_Policy_PaymentStatus_Paid');
                this.installment_status = `${total - RemainingBillingCycles} ${(0, locale_1.t)('Boats_Policy_Of')} ${total}`;
            }
        }
        this.payment_status_title = this.getPaymentStatusTitle();
        return {
            payment_status: this.payment_status,
            showDownPaymentLine: this.showDownPaymentLine,
            showDue: this.showDue,
            payment_status_title: this.payment_status_title,
            installment_status: this.installment_status,
        };
    }
    /** Always "Payment status"; the cycle count lives in its own `installment_status` row now. */
    getPaymentStatusTitle() {
        return this.payment_status_title;
    }
    /** Don't show dates if issuanceDate = cancellationDate,
    *  meaning the policy was cancelled before it started
    */
    getShowDates() {
        return this.issuanceDate !== this.cancellationDate;
    }
    getPaymentMethod() {
        return this.policy?.PaymentMethod == 'bank_account' ? `Bank Account ${this.policy?.BankAccountField || ''}`
            : this.policy?.PaymentMethod == 'card' ? `Credit Card ${this.policy?.CardNumber || ''}`
                : 'Processing ...';
    }
    getPremiumAmount() {
        return this.policy?.PremiumAmount || this.policy?.PremiumAmount === 0 ? `$${this.policy?.PremiumAmount}` : 'Processing ...';
    }
    getPolicyValidDates() {
        const formatValue = ({ dateValue }) => {
            if (!dateValue)
                return '';
            // Normalise separators so Date can parse YYYY-MM-DD or YYYY/MM/DD
            const normalised = dateValue.replace(/-/g, '/');
            const d = new Date(normalised);
            if (isNaN(d.getTime()))
                return dateValue;
            return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        };
        const showDates = this.getShowDates();
        const issuanceDateFormatted = formatValue({ dateValue: this.issuanceDate });
        const dateToDisplayUntilFormatted = formatValue({ dateValue: this.dateToDisplayUntil });
        const policyValidDates = this.policy?.IssuanceDate ? `${issuanceDateFormatted} — ${dateToDisplayUntilFormatted}` : 'Processing ...';
        return showDates ? policyValidDates : '';
    }
    setDateToDisplayUntil() {
        /** If cancellation date exists, it will be displayed instead of expiration date */
        const showDates = this.getShowDates();
        if (showDates)
            this.dateToDisplayUntil = this.cancellationDate?.length ? this.cancellationDate : this.expirationDate;
    }
    getPolicyBillingData() {
        //eslint-disable-next-line no-unsafe-optional-chaining
        let { payment_status, showDownPaymentLine, showDue, payment_status_title, installment_status } = policyBillingDataInstance?.getPaymentStatusAndDownpayment();
        const policyStatusToLowercase = policyBillingDataInstance?.getPolicyStatusToLowercase();
        const showDates = policyBillingDataInstance?.getShowDates();
        policyBillingDataInstance?.setDateToDisplayUntil();
        const payment_method = policyBillingDataInstance?.getPaymentMethod();
        const premium_amount = policyBillingDataInstance?.getPremiumAmount();
        const policy_valid_dates = policyBillingDataInstance?.getPolicyValidDates();
        return { payment_status, showDownPaymentLine, showDue, payment_status_title, installment_status, policyStatusToLowercase, showDates, payment_method, premium_amount, policy_valid_dates };
    }
}
exports.PolicyBillingDataService = PolicyBillingDataService;
